import { html } from '@beunity/lit-components';
import BaseMenu from '@beunity/lit-components/components/base_menu/element.js';
import translations from './translations.js';
import '@beunity/lit-components/components/dot_menu/element.js';

/**
 * The dot-dot-dot menu for communities offerings
 *
 * @prop serviceUrl - The url to execute the service action
 * @prop itemUrl - The url to execute the item action

 */

export default class GroupOfferingsMenu extends BaseMenu {
  /** @internal */
  static translations = translations;

  static properties = {
    serviceUrl: { type: String },
    itemUrl: { type: String },
  };

  /** @internal */
  get instanceId() {
    return 'offerings-index';
  }

  /** @internal */
  get serviceItem() {
    return {
      title: this.t('actions.service'),
      action: this.actionFor('offeringsExecJSFromResponse', [this.serviceUrl]),
      icon: 'hand-holding-hand',
      partName: 'service',
    };
  }

  /** @internal */
  get nonServiceItem() {
    return {
      title: this.t('actions.item'),
      action: this.actionFor('offeringsExecJSFromResponse', [this.itemUrl]),
      icon: 'wrench',
      partName: 'item',
    };
  }
  /** @internal */
  get items() {
    return [this.serviceItem, this.nonServiceItem];
  }

  /** @internal */
  get dotMenuConfig() {
    return {
      buttons: this.items,
      header: this.t('title'),
      showCancel: true,
    };
  }

  actionFor(method, args) {
    return {
      menu: 'bu-group-offerings-menu',
      id: this.instanceId,
      method: method,
      ...(args && { args: args }),
    };
  }

  offeringsExecJSFromResponse(url) {
    this.commonActions.execJSFromResponse(url);
  }

  render() {
    return html`
      <ef-dot-menu .config=${this.dotMenuConfig}>
        <slot name="trigger" slot="trigger">
          <button>Create</button>
        </slot>
      </ef-dot-menu>
    `;
  }
}

GroupOfferingsMenu.registerTagName('bu-group-offerings-menu');
GroupOfferingsMenu.registerCommonActions('bu-group-offerings-menu');

customElements.get('bu-group-offerings-menu') ||
  customElements.define('bu-group-offerings-menu', GroupOfferingsMenu);
